export const DEFAULT_SCHEDULE = [
    {
        date: '2015-11-30T00:00:00Z',
        intervals: [
            {
                open: '2015-11-30T08:00:00Z',
                close: '2015-11-30T16:30:00Z',
            },
        ],
    },
    {
        date: '2015-12-01T00:00:00Z',
        intervals: [
            {
                open: '2015-12-01T08:00:00Z',
                close: '2015-12-01T16:30:00Z',
            },
        ],
    },
    {
        date: '2015-12-02T00:00:00Z',
        intervals: [
            {
                open: '2015-12-02T08:00:00Z',
                close: '2015-12-02T16:30:00Z',
            },
        ],
    },
    {
        date: '2015-12-03T00:00:00Z',
        intervals: [
            {
                open: '2015-12-03T08:00:00Z',
                close: '2015-12-03T16:30:00Z',
            },
        ],
    },
    {
        date: '2015-12-04T00:00:00Z',
        intervals: [
            {
                open: '2015-12-04T08:00:00Z',
                close: '2015-12-04T16:30:00Z',
            },
        ],
    },
    {
        date: '2015-12-05T00:00:00Z',
        intervals: [
            {
                open: '2015-12-05T08:00:00Z',
                close: '2015-12-05T16:30:00Z',
            },
        ],
    },
    {
        date: '2015-12-06T00:00:00Z',
        intervals: [
            {
                open: '2015-12-06T08:00:00Z',
                close: '2015-12-06T16:30:00Z',
            },
        ],
    },
];
